<template>
  <div id="app" style="padding: 0px;margin: 0px;">
    <router-view></router-view>
  </div>
</template>

<script>
import theme from "theme-vue";
import {getValue} from '@/utils/localStorage'
export default {
  name: 'App',
  components: {},
  created() {
    this.initTheme();
  },
  methods:{
    initTheme(){
      const th = new theme();
      let themeJson = getValue("theme");
      if(themeJson){
        let th = JSON.parse(themeJson);
        this.$store.dispatch("changeTheme", th)
      }else {
        themeJson = {
          // mainTheme:"#13c2c2",
          // sideTheme:"#031c1c",
          // logoTheme:"#042c2c",
          // headerTheme:"#042c2c"
          mainTheme:"#1890ff",
          sideTheme:"#001223",
          logoTheme:"#001223",
          headerTheme:"#0D60E2"
        }
        th.changeTheme(themeJson.mainTheme)
        this.$store.dispatch("changeTheme", themeJson)
      }
    }
  }
}
</script>

<style lang='scss'>
  ::-webkit-scrollbar { /*滚动条整体样式*/
      // width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
      // height: 1px;
    }

  ::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #075786;
  }

  ::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: transparent;
  }
</style>
